import Model from '../Model'

export default class UserReport extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/user-reports'
    }
}
